import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    datas: [],
    totalCount: 0,
    coinTypes: []
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item,
        type: item.type || 'SPOT'
      }));
    }
  },
  mutations: {
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
    setList(state, payload) {
      state.datas = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getCoinTypes({ commit }) {
      api.getCoinTypes().then(({ data }) => {
        commit('setCoinTypes', data);
      });
    },
    reqList({ commit }, query) {
      api.reqList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    transfer(context, data) {
      return api.transfer(data).then(res => res);
    },
    mockTransfer(context, data) {
      return api.mockTransfer(data).then(res => res);
    }
  }
};

appStore.registerModule('transferInner', store);
